(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8014],{

/***/ 20738:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/listing/[...listing]",
      function () {
        return __webpack_require__(1390);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pages_jobs_style_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84306);
/* harmony import */ var _pages_jobs_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_pages_jobs_style_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var modules_JobListing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72781);
/* harmony import */ var modules_UserLoggedinContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74304);






var JobsList = function(param) {
    var jobs = param.jobs, similarJobs = param.similarJobs, query = param.query, jobSpecialities = param.jobSpecialities, metadata = param.metadata, showSubSpecialtyFormFilter = param.showSubSpecialtyFormFilter, disableEnquireAndWithdrawButtons = param.disableEnquireAndWithdrawButtons;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(modules_UserLoggedinContainer__WEBPACK_IMPORTED_MODULE_4__/* .UserLoggedinContainer */ .C, {
        size: "lg",
        className: (_pages_jobs_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().jobListContainer),
        style: modules_UserLoggedinContainer__WEBPACK_IMPORTED_MODULE_4__/* .ContainerStyle.TINY_BLUE_BANNER */ .N.TINY_BLUE_BANNER,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: metadata.title,
                description: metadata.description,
                openGraph: {
                    title: metadata.title,
                    description: metadata.description,
                    type: "website"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_JobListing__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                jobs: jobs,
                similarJobs: similarJobs,
                query: query,
                jobSpecialities: jobSpecialities,
                showSubSpecialtyFormFilter: showSubSpecialtyFormFilter,
                disableEnquireAndWithdrawButtons: disableEnquireAndWithdrawButtons
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (JobsList);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2491,5675,1399,4872,807,9803,9043,2283,3496,2298,3437,8536,4577,5788,813,6723,7243,2628,933,7422,1241,7988,6379,9774,2888,179], function() { return __webpack_exec__(20738); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);